import React, { PropsWithChildren } from "react";
//#region types
import { ExtendedEntityPaginationProps } from "models/propTypes/navigationPropTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { Grid } from "@mui/material";
import { WChevronLeft, WChevronRight } from "utils/constants/iconDefinitions";
import RoundButton from "../buttons/roundButton";
import Icon from "../icon";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";

const ExtendedEntityPagination: React.FC<PropsWithChildren<ExtendedEntityPaginationProps>> = (props) => {
  const { textNext, textPrevious, actions } = props;
  const itemNext = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.stopPropagation();
    props.onNavigationNext && props.onNavigationNext();
  };

  const itemPrev = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.stopPropagation();
    props.onNavigationPrevious && props.onNavigationPrevious();
  };

  return (
    <Grid
      container
      justifyContent="space-between"
      alignItems="center"
      className={cssExports.extendedEntityPaginationContainer}
    >
      <Grid item>
        <Grid container alignItems="center" wrap="nowrap" className={cssExports.paginationNavigation}>
          <RoundButton
            size="sm"
            className={cssExports.white}
            hoverText={LocalizationHelperInstance.getFormattedMessage(textPrevious ?? TranslationKeys.Common.Previous)}
            hoverTextAsToolTip
            onClick={itemPrev}
            testId="paginationPreviousButton"
          >
            <Icon icon={WChevronLeft} />
          </RoundButton>
          <RoundButton
            size="sm"
            className={cssExports.white}
            hoverText={LocalizationHelperInstance.getFormattedMessage(textNext ?? TranslationKeys.Common.Next)}
            hoverTextAsToolTip
            onClick={itemNext}
            testId="paginationNextButton"
          >
            <Icon icon={WChevronRight} />
          </RoundButton>
          <Grid item className={cssExports.titleContainer}>
            {props.children}
          </Grid>
        </Grid>
      </Grid>
      {actions && <Grid item>{actions}</Grid>}
    </Grid>
  );
};

export default ExtendedEntityPagination;
